import React from "react";
import { Typography } from "antd";
import InfoCircleIcon from "components/Icons/InfoCircle";
import CommonModal, { CommonModalProps } from "components/ui-component/Modal";

const { Paragraph } = Typography;

export interface ConfirmationModalProps
  extends Omit<CommonModalProps, "children" | "footer"> {
  description?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "normal" | "danger";
  icon?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = "Are you sure?",
  description,
  onConfirm,
  onCancel,
  variant = "normal",
  icon = true,
  okText = "Yes",
  cancelText = "No",
  maskClosable = false,
  children,
  isLoading = false,
  ...rest
}) => {
  return (
    <CommonModal
      open={open}
      title={
        <div className="modal-title-icon">
          {icon && <InfoCircleIcon />}
          <span className="description">{title}</span>
        </div>
      }
      onOk={onConfirm}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{ danger: variant === "danger" }}
      maskClosable={maskClosable}
      isLoading={isLoading}
      {...rest}
    >
      <div className="d-flex align-items-start gap-3 font-14">
        <Paragraph className="font-14">{description}</Paragraph>
        {children && <div className="font-14">{children}</div>}
      </div>
    </CommonModal>
  );
};

export default ConfirmationModal;
